import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  getErrorLogs,
  getErrorLog,
  deleteErrorLogs,
  getErrorLogsSettings,
  putErrorLogsSettings,
  postErrorLogsSettingsRefresh,
} from 'services/api';
import { ErrorLogsFilters, ErrorLogsSettings } from './interface';

export const getErrorLogsAsync = createAsyncThunk(
  'errorLogs/getErrorLogs',
  async (filters: Partial<ErrorLogsFilters>) => {
    const response = await getErrorLogs(filters);
    return response?.data;
  },
);

export const getErrorLogAsync = createAsyncThunk(
  'errorLogs/getErrorLog',
  async (id: string) => {
    const response = await getErrorLog(id);
    return response?.data;
  },
);

export const deleteErrorLogsAsync = createAsyncThunk(
  'errorLogs/deleteAll',
  async () => {
    const response = await deleteErrorLogs();
    return response?.data;
  },
);

export const getErrorLogsSettingsAsync = createAsyncThunk(
  'errorLogs/getSettings',
  async () => {
    const response = await getErrorLogsSettings();
    return response?.data;
  },
);

export const putErrorLogsSettingsAsync = createAsyncThunk(
  'errorLogs/putSettings',
  async (data: ErrorLogsSettings) => {
    const response = await putErrorLogsSettings(data);
    return response?.data;
  },
);

export const postErrorLogsSettingsRefreshAsync = createAsyncThunk(
  'errorLogs/refreshSettings',
  async () => {
    const response = await postErrorLogsSettingsRefresh();
    return response?.data;
  },
);
